// extracted by mini-css-extract-plugin
module.exports = {"Adventure":"Practice_Adventure__Jvk64"};